var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { CacheKey } from '../../../shared/constants/cachekey.constants';
import { CacheService } from '../../../shared/services/cache.service';
import { Permission } from '../../../common/enums/permission.enum';
import { CommonService } from '../../../shared/services/common.service';
import { FormBuilder, Validators } from '@angular/forms';
import { Utils } from '../../../shared/Utils/utils';
import { SortOrder } from '../../constants/reports.constants';
import { AnonymousRetailSalesConstants } from '../../constants/anonymous-retail-orders.constants';
import { AnonymousRetailOrderService } from '../../services/anonymous-retail-order.service';
import { TranslateService } from '@ngx-translate/core';
import { NotificationType } from '../../enums/notification-types.enum';
import { AccessLevel } from '../../../common/enums/access-level.enum';
import { RetailBonusStatus } from '../../enums/retail-bonus-status.enum';
import { catchError } from 'rxjs/operators/catchError';
import { of } from 'rxjs/observable/of';
import { Subject } from 'rxjs';
import { exhaustMap } from 'rxjs/operators/exhaustMap';
import { concatMap, map, takeUntil } from 'rxjs/operators';
import { RowStatus } from '../../../shared/common/enumerations';
import { DecimalPipe } from '@angular/common';
import { Modal } from 'ngx-modal';
import * as moment from 'moment';
import { AppLoaderService } from '../../../shared/services/app-loader.service';
var AnonymousRetailOrderComponent = /** @class */ (function () {
    function AnonymousRetailOrderComponent(_cacheService, _commonService, _formbuilder, _decimalPipe, _anonymousRetailOrderService, _translatePipe, _loader) {
        this._cacheService = _cacheService;
        this._commonService = _commonService;
        this._formbuilder = _formbuilder;
        this._decimalPipe = _decimalPipe;
        this._anonymousRetailOrderService = _anonymousRetailOrderService;
        this._translatePipe = _translatePipe;
        this._loader = _loader;
        this.hasAnonymousRetailOrderPermission = [
            Permission.MANAGE_ANONYMOUS_RETAIL_ORDER_CREATE,
            Permission.MANAGE_ANONYMOUS_RETAIL_ORDER_EDIT,
            Permission.MANAGE_ANONYMOUS_RETAIL_ORDER_DELETE,
            Permission.MANAGE_ANONYMOUS_RETAIL_ORDER_APPROVE
        ];
        this.message = { msg: "", class: "", icon: "", value: false };
        this.isLoading = { retailStores: "", participatingStores: "" };
        this.date = new Date();
        this.yearValues = [];
        this.isDesc = true;
        this.sortOrderEnum = SortOrder;
        this.tableColumnName = AnonymousRetailSalesConstants;
        this.RetailBonusStatus = RetailBonusStatus;
        this.retailStoresParticipation = [];
        this.pageNumber = AnonymousRetailSalesConstants.PageNumber;
        this.pageSize = AnonymousRetailSalesConstants.PageSize;
        this.pageCount = 0;
        this.RetailBonusSalesData = [];
        this.hideButton = true;
        this.isUpdate = false;
        this.retailStores = [];
        this.overlay = false;
        this.updateStoreName = '';
        this.anonymousRetailOrderDetails = [];
        this.orderDetailPageNumber = AnonymousRetailSalesConstants.PageNumber;
        this.orderDetailPageSize = AnonymousRetailSalesConstants.PageSize;
        this.orderDetailPageCount = 0;
        this.isErrorOccured = false;
        this.noRecordExist = false;
        this.monthAndYear = [
            { monthName: "January", value: 1 }, { monthName: "February", value: 2 }, { monthName: "March", value: 3 },
            { monthName: "April", value: 4 }, { monthName: "May", value: 5 }, { monthName: "June", value: 6 },
            { monthName: "July", value: 7 }, { monthName: "August", value: 8 }, { monthName: "September", value: 9 },
            { monthName: "October", value: 10 }, { monthName: "November", value: 11 }, { monthName: "December", value: 12 }
        ];
        this.anonymousRetailOrderGenerationStatusList = [
            { id: 204, status: 'Pending' },
            { id: 205, status: 'Completed' },
            { id: 206, status: 'Failed' }
        ];
        this.paginationInstance = {
            id: 'shared-retail-sales-pagination',
            itemsPerPage: AnonymousRetailSalesConstants.PageSize,
            currentPage: AnonymousRetailSalesConstants.PageNumber
        };
        this.orderDetailPaginationInstance = {
            id: 'order-detail-pagination',
            itemsPerPage: AnonymousRetailSalesConstants.PageSize,
            currentPage: AnonymousRetailSalesConstants.PageNumber
        };
        this.deleteSub$ = new Subject();
        this.ngUnsubscribe = new Subject();
        this.digitsAndDecimals = [7, 3];
        this.isEnableViewOrderAndRegenerateOrder = false; // remove flag once task are planned view and regenerate orders
    }
    AnonymousRetailOrderComponent.prototype.ngOnInit = function () {
        this.initializeFilterForm();
        this.initializeCreateOrEditForm();
        this.populateYearValues();
        this.userInfo = this._cacheService.get(CacheKey.UserInfo);
        this.isAnonymousRetailCreatePermission = this.getPermissionLevel([this.hasAnonymousRetailOrderPermission[0]]);
        this.getRetailStores();
        this.initializeSub();
    };
    AnonymousRetailOrderComponent.prototype.initializeFilterForm = function () {
        this.FilteringListForm = this._formbuilder.group({
            store: [" ", [Validators.required, Utils.noEmptyString]],
            year: [" "],
            month: [" "]
        });
    };
    AnonymousRetailOrderComponent.prototype.initializeCreateOrEditForm = function () {
        this.CreateOrEditForm = this._formbuilder.group({
            store: [" ", [Validators.required, Utils.noEmptyString]],
            year: [{ value: '', disabled: true }, Validators.required],
            month: [{ value: '', disabled: true }, Validators.required],
            salesCC: [0, [Validators.required, Validators.pattern(/^\d{1,7}(\.\d{0,3})?$/)]]
        });
    };
    /**
   * populate year dropdown values based on specific year
   */
    AnonymousRetailOrderComponent.prototype.populateYearValues = function () {
        var year = +AnonymousRetailSalesConstants.YearValue;
        var curYear = +this.date.getFullYear();
        var YearDiff = curYear - year;
        for (var i = 0; i <= YearDiff; i++) {
            this.yearValues.push(year + i);
        }
        this.yearValues.sort();
        this.FilteringListForm.get('year').setValue(this.date.getFullYear());
        this.FilteringListForm.get('month').setValue(this.date.getMonth() + 1);
    };
    AnonymousRetailOrderComponent.prototype.getPermissionLevel = function (hasAnonymousRetailOrderPermission) {
        return this._anonymousRetailOrderService.getAnonymousRetailAccess(hasAnonymousRetailOrderPermission);
    };
    /**
     * get retail participating store in search screen
     */
    AnonymousRetailOrderComponent.prototype.getRetailStores = function () {
        var _this = this;
        this.isLoading.participatingStores = AnonymousRetailSalesConstants.participatingStores;
        this._anonymousRetailOrderService.getRetailParticipatingStores().pipe(takeUntil(this.ngUnsubscribe)).subscribe(function (res) {
            if (res && res.success) {
                if (res.data && !!res.data.length) {
                    _this.retailStoresParticipation = _this.userInfo && _this.userInfo.hasSystemRole ? res.data.slice() : _this.populateRetailStores(res.data);
                }
                else {
                    _this.retailStoresParticipation = [];
                }
            }
            else {
                _this.retailStoresParticipation = [];
                _this.displayErrorMsg(res, _this._translatePipe.get('retail-orders.' + AnonymousRetailSalesConstants.Error_Occured_While_Retriving_Stores).value);
            }
            _this.isLoading.participatingStores = "";
            _this.overlay = false;
        }, function (err) {
            _this.retailStoresParticipation = [];
            _this.displayErrorMsg('', _this._translatePipe.get('retail-orders.' + AnonymousRetailSalesConstants.Error_Occured_While_Retriving_Stores).value);
            _this.isLoading.participatingStores = "";
        });
    };
    /**
     *
     * @param retailStoresData populate store based on user permission
     */
    AnonymousRetailOrderComponent.prototype.populateRetailStores = function (retailStoresData) {
        var _this = this;
        var userAllowedStores = this.userInfo && this.userInfo.privileges && this.userInfo.privileges.stores ? this.userInfo.privileges.stores : [];
        var compareUserWithRetailStores = userAllowedStores ? userAllowedStores.filter(function (permission) { return retailStoresData.find(function (stores) { return stores.id == permission.id; }); }) : [];
        var checkRetailAccessStores = compareUserWithRetailStores ? compareUserWithRetailStores.filter(function (userStores) { return userStores.permissions.some(function (stores) { return _this.hasAnonymousRetailOrderPermission.includes(stores); }); }) : [];
        var retailParticipationStores = checkRetailAccessStores ? checkRetailAccessStores.map(function (stores) { return retailStoresData.find(function (participatingStores) { return participatingStores.id == stores.id; }); }) : [];
        return retailParticipationStores.slice();
    };
    /**
   * get retail bonus sales record
   */
    AnonymousRetailOrderComponent.prototype.getRetailBonusSalesRecords = function () {
        var _this = this;
        if (this.FilteringListForm.valid) {
            this.overlay = true;
            var retailBonusObj = {
                storeID: +this.FilteringListForm.get('store').value,
                year: +this.FilteringListForm.get('year').value,
                month: +this.FilteringListForm.get('month').value,
                pageNumber: +this.pageNumber,
                pageSize: +this.pageSize,
                sort: this.isDesc ? AnonymousRetailSalesConstants.DESC : AnonymousRetailSalesConstants.ASC,
                sortColumn: this.sortColumn
            };
            if (this.FilteringListForm && this.FilteringListForm.get('store').value) {
                this.storeId = this.FilteringListForm.get('store').value;
            }
            this._anonymousRetailOrderService.getRetailBonusSales(retailBonusObj).pipe(concatMap(function (salesRecords) {
                var userIds = salesRecords.data.map(function (userid) { return userid.approvedBy; }).filter(function (value, index, self) { return (value && self.indexOf(value) === index); });
                return userIds && userIds.length > 0 ? _this._anonymousRetailOrderService.getUsersDetails(userIds).pipe(catchError(function (err) { return of([salesRecords, []]); }), map(function (userIDS) { return [salesRecords, userIDS]; })) : of([salesRecords, []]);
            }), map(function (_a) {
                var salesRecords = _a[0], userIDS = _a[1];
                return (__assign({}, salesRecords, { data: (salesRecords && salesRecords.data && !!salesRecords.data.length) ? salesRecords.data.map(function (sales) {
                        var approvedBy = userIDS.find(function (user) { return user.id === sales.approvedBy; });
                        sales.approvedBy = approvedBy ? approvedBy.userName : "";
                        return sales;
                    }) : [] }));
            }), takeUntil(this.ngUnsubscribe)).subscribe(function (res) {
                var salesRecords = res;
                _this.populateSalesRecords(salesRecords);
                _this.overlay = false;
            }, function (err) {
                _this.resetRetailSalesValues();
                _this.displayErrorMsg('', _this._translatePipe.get('retail-orders.' + AnonymousRetailSalesConstants.Error_Occured_While_Retail_Sales_Info).value);
            });
        }
    };
    /**
     * Based on salesRecords bind the values to grid
     * @param salesRecords
     */
    AnonymousRetailOrderComponent.prototype.populateSalesRecords = function (salesRecords) {
        if (salesRecords && salesRecords.isSuccess && salesRecords.data && !!salesRecords.data.length) {
            var _loop_1 = function (i) {
                var store = this_1.retailStoresParticipation.filter(function (country) { return +country.id == +salesRecords.data[i].storeID; })[0];
                salesRecords.data[i].storeName = store ? store.name : salesRecords.data[i].storeID;
                salesRecords.data[i].isEdit = this_1._commonService.checkPermissionByAccessLevel(JSON.parse('[' + Permission.MANAGE_ANONYMOUS_RETAIL_ORDER_EDIT + ']'), AccessLevel.Store, +salesRecords.data[i].storeID);
                salesRecords.data[i].isDelete = this_1._commonService.checkPermissionByAccessLevel(JSON.parse('[' + Permission.MANAGE_ANONYMOUS_RETAIL_ORDER_DELETE + ']'), AccessLevel.Store, +salesRecords.data[i].storeID);
                salesRecords.data[i].isCreate = this_1._commonService.checkPermissionByAccessLevel(JSON.parse('[' + Permission.MANAGE_ANONYMOUS_RETAIL_ORDER_CREATE + ']'), AccessLevel.Store, +salesRecords.data[i].storeID);
                salesRecords.data[i].isApprove = this_1._commonService.checkPermissionByAccessLevel(JSON.parse('[' + Permission.MANAGE_ANONYMOUS_RETAIL_ORDER_APPROVE + ']'), AccessLevel.Store, +salesRecords.data[i].storeID);
                salesRecords.data[i].orderCC = salesRecords.data[i].orderCC ? this_1._decimalPipe.transform(salesRecords.data[i].orderCC, '1.3-3').replace(/,/g, '') : salesRecords.data[i].orderCC;
                salesRecords.data[i].orderTotal = salesRecords.data[i].orderTotal ? this_1._decimalPipe.transform(salesRecords.data[i].orderTotal, '1.2-2').replace(/,/g, '') : salesRecords.data[i].orderTotal;
                salesRecords.data[i].currencyCode = store ? store.currencyCode : '';
                salesRecords.data[i].totalSalesCC = salesRecords.data[i].totalSalesCC ? this_1._decimalPipe.transform(salesRecords.data[i].totalSalesCC, '1.3-3').replace(/,/g, '') : salesRecords.data[i].totalSalesCC;
                salesRecords.data[i].isShowRegenerateOrder = salesRecords.data[i].isShowRegenerateOrder;
            };
            var this_1 = this;
            for (var i = 0; i < salesRecords.data.length; i++) {
                _loop_1(i);
            }
            this.RetailBonusSalesData = salesRecords.data.slice();
            this.pageCount = salesRecords.pageDetails && (salesRecords.pageDetails.recordsAll).toString() ? +salesRecords.pageDetails.recordsAll : 0;
        }
        else if (salesRecords && !salesRecords.isSuccess && salesRecords.validations && !!salesRecords.validations.length) {
            if (salesRecords.validations[0].name && salesRecords.validations[0].name.toLowerCase() == AnonymousRetailSalesConstants.FAILED) {
                var errorMsg = this._translatePipe.get('retail-orders.Exception occurred while fetching shared retail sales info for store {{storeID}}, year {{year}}, month {{month}}', {
                    storeID: this.FilteringListForm.get('store').value ? this.FilteringListForm.get('store').value : '',
                    year: this.date.getFullYear(),
                    month: this.date.getMonth() + 1
                }).value;
                this._commonService.createNotification("", errorMsg, NotificationType.ERROR);
            }
            else if (salesRecords.validations[0].name && salesRecords.validations[0].name.toLowerCase() == AnonymousRetailSalesConstants.Completed) {
                var errorMsg = this._translatePipe.get('retail-orders.No records for shared retail sales info for store {{storeID}}, year {{year}}, month {{month}}', {
                    storeID: this.FilteringListForm.get('store').value ? this.FilteringListForm.get('store').value : '',
                    year: this.date.getFullYear(),
                    month: this.date.getMonth() + 1
                }).value;
                this._commonService.createNotification("", errorMsg, NotificationType.ERROR);
            }
            else {
                var msg = salesRecords.validations[0].message ? salesRecords.validations[0].message : AnonymousRetailSalesConstants.Error_Occured_While_Retail_Sales_Info;
                this._commonService.createNotification("", this._translatePipe.get('retail-orders.' + msg).value, NotificationType.ERROR);
            }
            this.resetRetailSalesValues();
        }
        else {
            this.resetRetailSalesValues();
        }
    };
    AnonymousRetailOrderComponent.prototype.resetRetailSalesValues = function () {
        this.RetailBonusSalesData = [];
        this.pageCount = 0;
        this.pageSize = AnonymousRetailSalesConstants.PageSize;
        this.pageNumber = AnonymousRetailSalesConstants.PageNumber;
    };
    AnonymousRetailOrderComponent.prototype.openRetailModal = function (value, data) {
        this.hideButton = true;
        this.recordId = " ";
        this.enableformControls();
        this.resetErrorMessage();
        this.resetCreateOrEdit();
        if (value.toLowerCase() == AnonymousRetailSalesConstants.CREATE.toLowerCase()) {
            this.retailStores = [];
            this.CreateOrEditForm.get('year').setValue(this.date.getFullYear());
            this.CreateOrEditForm.get('month').setValue(this.date.getMonth() + 1);
            this.CreateOrEditForm.get('salesCC').setValue(this._decimalPipe.transform(0, '1.3-3'));
            this.recordId = "";
            this.isUpdate = false;
            this.getStoreData();
        }
        else {
            this.isUpdate = true;
            this.CreateOrEditForm.get('store').setValue(data.storeID.toString());
            this.CreateOrEditForm.get('year').setValue(data.salesYear);
            this.CreateOrEditForm.get('month').setValue(data.salesMonth);
            (data && data.totalSalesCC.toString()) ?
                this.CreateOrEditForm.get('salesCC').setValue(this._decimalPipe.transform(data.totalSalesCC, '1.3-3').replace(/,/g, '')) :
                this.CreateOrEditForm.get('salesCC').setValue(this._decimalPipe.transform(0, '1.3-3'));
            this.recordId = +data.id;
            this.updateStoreName = data.storeName;
        }
        this.AnonymousRetailOrdersPopup.open();
    };
    AnonymousRetailOrderComponent.prototype.closeRetailModal = function () {
        this.resetErrorMessage();
        this.resetCreateOrEdit();
        this.AnonymousRetailOrdersPopup.close();
    };
    /**
     * create a new/update record anonymous retail sales record
     */
    AnonymousRetailOrderComponent.prototype.onSubmit = function () {
        if (this.CreateOrEditForm.valid) {
            this.hideButton = false;
            this.resetErrorMessage();
            var createRetailSalesObj = {
                storeId: +this.CreateOrEditForm.get('store').value,
                salesYear: +this.CreateOrEditForm.get('year').value,
                salesMonth: +this.CreateOrEditForm.get('month').value,
                totalSalesCC: +this.CreateOrEditForm.get('salesCC').value
            };
            if (this.isUpdate) {
                createRetailSalesObj.updatedBy = +this.userInfo.userId;
                createRetailSalesObj.id = +this.recordId;
                this.updateAnonyumousRetailSales(createRetailSalesObj, false);
            }
            else {
                createRetailSalesObj.createdBy = +this.userInfo.userId;
                this.addNewAnonyumousRetailSales(createRetailSalesObj);
            }
        }
    };
    AnonymousRetailOrderComponent.prototype.addNewAnonyumousRetailSales = function (createRetailSalesObj) {
        var _this = this;
        if (this.CreateOrEditForm.valid) {
            this._anonymousRetailOrderService.createRetailBonusSales(createRetailSalesObj).pipe(takeUntil(this.ngUnsubscribe)).subscribe(function (res) {
                if (res && res.isSuccess && res.validations && res.validations.length == 0) {
                    var message = _this._translatePipe.get('retail-orders.Sales entry created Successfully').value;
                    var modalStore_1 = _this.CreateOrEditForm.get('store').value ? _this.CreateOrEditForm.get('store').value.toString() : '';
                    var searchStore = (modalStore_1 && _this.retailStoresParticipation && !!_this.retailStoresParticipation.length) ? _this.retailStoresParticipation.find(function (storeID) { return ((storeID.id).toString()) == modalStore_1; }) : '';
                    if (searchStore && searchStore.id) {
                        _this.FilteringListForm.get('store').setValue((searchStore.id).toString());
                        _this.FilteringListForm.get('year').setValue(_this.date.getFullYear());
                        _this.FilteringListForm.get('month').setValue(_this.date.getMonth() + 1);
                    }
                    _this.handleSuccessResponse(message);
                }
                else {
                    _this.displayModalErrorMsg(res, _this._translatePipe.get('retail-orders.' + AnonymousRetailSalesConstants.ARS_Create_Error).value, createRetailSalesObj.storeId, AnonymousRetailSalesConstants.CREATE);
                }
            }, function (err) {
                _this.displayModalErrorMsg('', _this._translatePipe.get('retail-orders.' + AnonymousRetailSalesConstants.ARS_Create_Error).value);
            });
        }
    };
    AnonymousRetailOrderComponent.prototype.updateAnonyumousRetailSales = function (createRetailSalesObj, isDelete) {
        var _this = this;
        this._anonymousRetailOrderService.updateOrDeleteRetailBonusSales(createRetailSalesObj, isDelete).pipe(takeUntil(this.ngUnsubscribe)).subscribe(function (res) {
            if (res && res.isSuccess) {
                var message = _this._translatePipe.get('retail-orders.Sales entry updated Successfully').value;
                _this.handleSuccessResponse(message);
            }
            else {
                _this.displayModalErrorMsg(res, _this._translatePipe.get('retail-orders.' + AnonymousRetailSalesConstants.ARS_Update_Error).value, createRetailSalesObj.id, AnonymousRetailSalesConstants.UPDATE);
            }
        }, function (err) {
            _this.displayModalErrorMsg('', _this._translatePipe.get('retail-orders.' + AnonymousRetailSalesConstants.ARS_Update_Error).value);
        });
    };
    /**
     * Confirmation popup modal
     * @param data
     */
    AnonymousRetailOrderComponent.prototype.confirmation = function (data) {
        this.hideButton = true;
        this.recordId = data.id;
        this.setValuesToForm(data);
        this.resetErrorMessage();
        this.confirmationModalPopup.open();
    };
    AnonymousRetailOrderComponent.prototype.deleteRetailSalesRecord = function () {
        this.hideButton = false;
        this.resetErrorMessage();
        var createRetailSalesObj = {
            storeId: this.CreateOrEditForm.get('store').value ? +this.CreateOrEditForm.get('store').value : '',
            salesYear: +this.CreateOrEditForm.get('year').value,
            salesMonth: +this.CreateOrEditForm.get('month').value,
            totalSalesCC: +((this.CreateOrEditForm.get('salesCC').value).replace(/,/g, '')),
            updatedBy: +this.userInfo.userId,
            id: this.recordId
        };
        this.deleteSub$.next(createRetailSalesObj);
    };
    AnonymousRetailOrderComponent.prototype.initializeSub = function () {
        var _this = this;
        this.deleteSub$.pipe(exhaustMap(function (reqObj) {
            return _this._anonymousRetailOrderService.updateOrDeleteRetailBonusSales(reqObj, true)
                .pipe(catchError(function (err) { return of({ isError: true, err: err }); }));
        })).subscribe(function (res) {
            if (res.isError) {
                var message = _this._translatePipe.get('retail-orders.' + AnonymousRetailSalesConstants.ARS_Delete_Error).value;
                _this.handleErrorResponse(message);
                return;
            }
            if (res && res.isSuccess) {
                _this.hideButton = true;
                var message = _this._translatePipe.get('retail-orders.Sales entry deleted Successfully');
                _this._commonService.createNotification("", message.value, NotificationType.SUCCESS);
                _this.getRetailBonusSalesRecords();
                _this.closeConfirmationPopup();
            }
            else {
                _this.displayModalErrorMsg(res, _this._translatePipe.get('retail-orders.' + AnonymousRetailSalesConstants.ARS_Delete_Error).value, _this.recordId, AnonymousRetailSalesConstants.DELETE);
            }
        }, function (err) {
            _this.displayModalErrorMsg('', _this._translatePipe.get('retail-orders.' + AnonymousRetailSalesConstants.ARS_Delete_Error).value);
        });
    };
    AnonymousRetailOrderComponent.prototype.closeConfirmationPopup = function () {
        this.resetErrorMessage();
        this.recordId = "";
        this.confirmationModalPopup.close();
    };
    AnonymousRetailOrderComponent.prototype.handleSuccessResponse = function (message) {
        this.hideButton = false;
        this._commonService.createNotification("", message, NotificationType.SUCCESS);
        this.CreateOrEditForm.get('store').disable();
        this.CreateOrEditForm.get('salesCC').disable();
        this.closeRetailModal();
        this.getRetailBonusSalesRecords();
    };
    AnonymousRetailOrderComponent.prototype.handleErrorResponse = function (message) {
        this.hideButton = true;
        this.populateErrormMessages(message, NotificationType.ERROR, true, AnonymousRetailSalesConstants.CloseIcon);
    };
    /**
     * reset the CreateOrEdit form
     */
    AnonymousRetailOrderComponent.prototype.resetCreateOrEdit = function () {
        this.CreateOrEditForm.get('store').setValue('');
        this.CreateOrEditForm.get('year').setValue(" ");
        this.CreateOrEditForm.get('month').setValue(" ");
        this.CreateOrEditForm.get('salesCC').setValue(this._decimalPipe.transform(0, '1.3-3'));
        this.CreateOrEditForm.get('store').markAsUntouched();
    };
    AnonymousRetailOrderComponent.prototype.resetFilterForm = function () {
        this.overlay = true;
        this.FilteringListForm.get('store').setValue(" ");
        this.FilteringListForm.get('year').setValue(this.date.getFullYear());
        this.FilteringListForm.get('month').setValue(this.date.getMonth() + 1);
        this.isDesc = true;
        this.sortColumn = null;
        this.pageNumber = AnonymousRetailSalesConstants.PageNumber;
        this.pageSize = AnonymousRetailSalesConstants.PageSize;
        this.RetailBonusSalesData = [];
        this.pageCount = 0;
        this.FilteringListForm.get('store').markAsUntouched();
        this.getRetailStores();
    };
    /**
       * Sort by column name
       * @param sortColumn
       */
    AnonymousRetailOrderComponent.prototype.sortByColumn = function (sortColumn) {
        if (this.FilteringListForm.valid) {
            this.isDesc = (this.sortColumn == sortColumn || sortColumn == "") ? !this.isDesc : this.isDesc;
            this.sortColumn = sortColumn;
            this.getRetailBonusSalesRecords();
        }
        else {
            var message = this._translatePipe.get('retail-orders.Please select store to perform any action').value;
            this._commonService.createNotification("", message, NotificationType.ERROR);
        }
    };
    AnonymousRetailOrderComponent.prototype.populateErrormMessages = function (message, type, val, icon) {
        this.message.msg = message;
        this.message.class = type;
        this.message.value = val;
        this.message.icon = icon;
    };
    /**
     * reset the error messages
     */
    AnonymousRetailOrderComponent.prototype.resetErrorMessage = function () {
        this.message.msg = " ";
        this.message.class = "";
        this.message.icon = "";
        this.message.value = false;
    };
    /**
     * enable the form controls
     */
    AnonymousRetailOrderComponent.prototype.enableformControls = function () {
        this.CreateOrEditForm.get('store').enable();
        this.CreateOrEditForm.get('salesCC').enable();
    };
    /**
    * On Page change
    * @param pageNumber
    */
    AnonymousRetailOrderComponent.prototype.pageChange = function (pageNumber) {
        if (!isNaN(pageNumber)) {
            this.pageNumber = pageNumber;
            this.getRetailBonusSalesRecords();
        }
    };
    /**
    * On Page change
    * @param pageNumber
    */
    AnonymousRetailOrderComponent.prototype.pageChangeForOrderDetail = function (pageNumber) {
        if (!isNaN(pageNumber)) {
            this.orderDetailPageNumber = pageNumber;
            this.OnclickViewOrders();
        }
    };
    /**
     * populate stores in popup up model
     */
    AnonymousRetailOrderComponent.prototype.getStoreData = function () {
        var _this = this;
        this.isLoading.retailStores = AnonymousRetailSalesConstants.currentRetailStores;
        this.resetErrorMessage();
        var month = (+this.CreateOrEditForm.get('month').value);
        var year = +this.CreateOrEditForm.get('year').value;
        if (month && year) {
            this._anonymousRetailOrderService.getStoreDetails(month, year).pipe(takeUntil(this.ngUnsubscribe)).subscribe(function (res) {
                if (res && res.isSuccess) {
                    _this.retailStores = (res.data && !!res.data.length) ? _this.populateStoreInModal(res) : [];
                }
                else {
                    _this.retailStores = [];
                    _this.displayModalErrorMsg(res, _this._translatePipe.get('retail-orders.' + AnonymousRetailSalesConstants.Error_occured_while_fetching_stores).value);
                }
                _this.isLoading.retailStores = "";
            }, function (err) {
                _this.retailStores = [];
                _this.displayModalErrorMsg('', _this._translatePipe.get('retail-orders.' + AnonymousRetailSalesConstants.Error_occured_while_fetching_stores).value);
                _this.isLoading.retailStores = "";
            });
        }
    };
    AnonymousRetailOrderComponent.prototype.displayModalErrorMsg = function (res, errMsg, id, action) {
        var message = res && res.validations && !!res.validations.length && res.validations[0].message ? this.handleErrorMsg(res.validations, errMsg, id, action) : errMsg;
        this.handleErrorResponse(message);
    };
    AnonymousRetailOrderComponent.prototype.handleErrorMsg = function (validationMsg, errMsg, id, action) {
        var errorMsg = " ";
        if (validationMsg[0] && validationMsg[0].name) {
            if (validationMsg[0].name.toLowerCase() == AnonymousRetailSalesConstants.Already_Exist.toLowerCase() && action == AnonymousRetailSalesConstants.CREATE) {
                errorMsg = this._translatePipe.get('retail-orders.Shared retail sales is already exists for this store {{storeID}}', { storeID: id ? id : '' }).value;
                return errorMsg;
            }
            if (validationMsg[0].name.toLowerCase() == AnonymousRetailSalesConstants.Not_Exist.toLowerCase() && (action == AnonymousRetailSalesConstants.UPDATE || action == AnonymousRetailSalesConstants.DELETE)) {
                errorMsg = this._translatePipe.get('retail-orders.Shared retail sale details is not available for this id {{arsid}}', { arsid: id ? id : '' }).value;
                return errorMsg;
            }
            if (validationMsg[0].name.toLowerCase() == AnonymousRetailSalesConstants.Request_failed.toLowerCase()) {
                errorMsg = this._translatePipe.get('retail-orders.Error while fetching the store for shared retail sales').value;
                return errorMsg;
            }
            if (validationMsg[0].name.toLowerCase() == AnonymousRetailSalesConstants.Completed.toLowerCase()) {
                errorMsg = this._translatePipe.get('retail-orders.Stores are not available for this current period {{month}}-{{year}}', {
                    month: this.date.getMonth() + 1,
                    year: this.date.getFullYear()
                }).value;
                return errorMsg;
            }
            if (validationMsg[0].name.toLowerCase() == AnonymousRetailSalesConstants.FAILED.toLowerCase() || validationMsg[0].name.toLowerCase() == AnonymousRetailSalesConstants.Error.toLowerCase()) {
                if (action == AnonymousRetailSalesConstants.Revise) {
                    errorMsg = this._translatePipe.get('retail-orders.Exception Occured while revising the shared retail order sales for id {{arsid}}', { arsid: id ? id : '' }).value;
                    return errorMsg;
                }
                if (action == AnonymousRetailSalesConstants.Approve) {
                    errorMsg = this._translatePipe.get('retail-orders.Error while approving the shared retail sales for id {{arsid}}', { arsid: id ? id : '' }).value;
                    return errorMsg;
                }
                errorMsg = this._translatePipe.get('retail-orders.' + validationMsg[0].message).value;
                return errorMsg;
            }
        }
        errorMsg = this._translatePipe.get('retail-orders.' + errMsg).value;
        return errorMsg;
    };
    AnonymousRetailOrderComponent.prototype.populateStoreInModal = function (res) {
        res = __assign({}, res, { data: res.data.filter(function (stores) { return stores.rowStatusId == RowStatus.Active; }) });
        var stores = [];
        if (this.userInfo && this.userInfo.hasSystemRole)
            return res.data.slice();
        for (var i = 0; i < res.data.length; i++) {
            var storeHasAccess = this._commonService.checkPermissionByAccessLevel(JSON.parse('[' + Permission.MANAGE_ANONYMOUS_RETAIL_ORDER_CREATE + ']'), AccessLevel.Store, +res.data[i].id);
            if (storeHasAccess) {
                stores.push(res.data[i]);
            }
        }
        return stores.slice();
    };
    AnonymousRetailOrderComponent.prototype.calculateTotalOrderCC = function (data) {
        var _this = this;
        var reqObj = {
            categoryName: AnonymousRetailSalesConstants.AnonymousRetailSales,
            categoryIdentifier: AnonymousRetailSalesConstants.RetailSales,
            templateName: "",
            templateExtension: "",
            templatePath: "",
            uploadSourceSystem: AnonymousRetailSalesConstants.CSP,
            destinationSource: AnonymousRetailSalesConstants.Account_Service,
            modifiedBy: this.userInfo.userId,
            fileUploadMetaDataModel: {
                storeId: data.storeID,
                templateIdentifier: data.id
            }
        };
        if (data && data.id && data.storeID) {
            this.overlay = true;
            this._anonymousRetailOrderService.calculateOrderTotalCC(reqObj).pipe(takeUntil(this.ngUnsubscribe)).subscribe(function (res) {
                if (res && res.success) {
                    var message = _this._translatePipe.get('retail-orders.' + AnonymousRetailSalesConstants.Calculate_Order_Total_CC_Initiated_Successfully);
                    _this._commonService.createNotification("", message.value, NotificationType.SUCCESS);
                    _this.getRetailBonusSalesRecords();
                }
                else {
                    _this.displayErrorMsg(res, _this._translatePipe.get('retail-orders.' + AnonymousRetailSalesConstants.Calculate_Order_Total_CC_Error).value);
                }
            }, function (err) {
                _this.displayErrorMsg('', _this._translatePipe.get('retail-orders.' + AnonymousRetailSalesConstants.Calculate_Order_Total_CC_Error).value);
            });
        }
    };
    AnonymousRetailOrderComponent.prototype.reviseRetailOrder = function (data) {
        var _this = this;
        if (data && data.id) {
            this.overlay = true;
            var revisedBy = this.userInfo.userId;
            this._anonymousRetailOrderService.reviseRetailOrder(data.id, revisedBy).pipe(takeUntil(this.ngUnsubscribe)).subscribe(function (res) {
                if (res && res.success) {
                    var message = _this._translatePipe.get('retail-orders.' + AnonymousRetailSalesConstants.Revise_Intitiated_Successfully);
                    _this._commonService.createNotification("", message.value, NotificationType.SUCCESS);
                    _this.getRetailBonusSalesRecords();
                }
                else {
                    _this.displayErrorMsg(res, _this._translatePipe.get('retail-orders.' + AnonymousRetailSalesConstants.Revise_Error).value, data.id, AnonymousRetailSalesConstants.Revise);
                }
            }, function (err) {
                _this.displayErrorMsg('', _this._translatePipe.get('retail-orders.' + AnonymousRetailSalesConstants.Revise_Error).value);
            });
        }
    };
    AnonymousRetailOrderComponent.prototype.trackByStoreID = function (index, store) {
        return store.id;
    };
    AnonymousRetailOrderComponent.prototype.trackBySales = function (index, retailSales) {
        return retailSales.id;
    };
    AnonymousRetailOrderComponent.prototype.setValuesToForm = function (data) {
        this.CreateOrEditForm.get('store').setValue(data.storeID.toString());
        this.CreateOrEditForm.get('year').setValue(data.salesYear);
        this.CreateOrEditForm.get('month').setValue(data.salesMonth);
        (data && data.totalSalesCC.toString()) ?
            this.CreateOrEditForm.get('salesCC').setValue(this._decimalPipe.transform(data.totalSalesCC, '1.3-3')) :
            this.CreateOrEditForm.get('salesCC').setValue(this._decimalPipe.transform(0, '1.3-3'));
    };
    AnonymousRetailOrderComponent.prototype.approve = function (salesId) {
        var _this = this;
        this.overlay = true;
        var CreatedBy = this.userInfo.userId;
        this._anonymousRetailOrderService.approveRetailOrder(salesId.id, CreatedBy).subscribe(function (res) {
            if (res && res.success) {
                var message = _this._translatePipe.get('retail-orders.' + AnonymousRetailSalesConstants.Approve_Intitiated_Successfully);
                _this._commonService.createNotification("", message.value, NotificationType.SUCCESS);
                _this.getRetailBonusSalesRecords();
            }
            else {
                _this.displayErrorMsg(res, _this._translatePipe.get('retail-orders.' + AnonymousRetailSalesConstants.Approve_Error).value, salesId.id, AnonymousRetailSalesConstants.Approve);
            }
        }, function (err) {
            _this.displayErrorMsg('', _this._translatePipe.get('retail-orders.' + AnonymousRetailSalesConstants.Approve_Error).value);
        });
    };
    AnonymousRetailOrderComponent.prototype.displayErrorMsg = function (res, errMsg, id, action) {
        var message = res && !res.success && res.validations && res.validations.length > 0 ? this.handleErrorMsg(res.validations, errMsg, id, action) : errMsg;
        this._commonService.createNotification("", message, NotificationType.ERROR);
        this.overlay = false;
    };
    AnonymousRetailOrderComponent.prototype.ngOnDestroy = function () {
        if (this.ngUnsubscribe) {
            this.ngUnsubscribe.next();
            this.ngUnsubscribe.complete();
        }
    };
    /**
     * View generated orders for anonymous retail sales
     * @param anonymousRetailSalesId
     */
    AnonymousRetailOrderComponent.prototype.OnclickViewOrders = function (anonymousRetailSalesId) {
        /**TODO::Need to uncomment once view order ticket is planned. */
        var _this = this;
        if (this.isEnableViewOrderAndRegenerateOrder) {
            this._loader.show();
            if (anonymousRetailSalesId) {
                this.anonymousRetailSalesId = anonymousRetailSalesId;
            }
            this.anonymousRetailOrderDetails = [];
            this.isErrorOccured = false;
            this.noRecordExist = false;
            this.viewOrdersPopup.open();
            var store_1 = this.retailStoresParticipation.filter(function (country) { return +country.id == _this.storeId; });
            this._anonymousRetailOrderService.getOrderdetails(this.anonymousRetailSalesId, this.orderDetailPageSize, this.orderDetailPageNumber).subscribe(function (response) {
                if (response && response.isSuccess && response.data && response.data.length) {
                    var _loop_2 = function (i) {
                        _this.anonymousRetailOrderDetail = {
                            distributorId: response.data[i].distributorId,
                            webOrderID: response.data[i].webOrderID,
                            orderCC: response.data[i].orderCC,
                            orderTotal: response.data[i].orderTotal,
                            orderGenerationStatus: _this.anonymousRetailOrderGenerationStatusList.find(function (element) { return response.data[i].orderGenerationStatus === element.id; }).status,
                            orderDate: response.data[i].orderDate ? moment.utc(response.data[i].orderDate).utcOffset(0).format('DD-MMM-YYYY') : '',
                            storeName: store_1[0].name,
                            currencyCode: store_1[0].currencyCode
                        };
                        _this.anonymousRetailOrderDetails.push(_this.anonymousRetailOrderDetail);
                    };
                    for (var i = 0; i < response.data.length; i++) {
                        _loop_2(i);
                    }
                    _this._loader.hide();
                    _this.orderDetailPageCount = (response.pageDetails) && response.pageDetails.recordsAll ? response.pageDetails.recordsAll : 0;
                }
                else {
                    _this.anonymousRetailOrderDetails = [];
                    _this._loader.hide();
                    _this.noRecordExist = true;
                }
            }, function () {
                _this.anonymousRetailOrderDetails = [];
                _this.isErrorOccured = true;
                _this._loader.hide();
            });
        }
    };
    /**
     * regenerate the failed orders
     */
    AnonymousRetailOrderComponent.prototype.OnclickRegenerateOrders = function () {
        var _this = this;
        var store = this.retailStoresParticipation.filter(function (country) { return +country.id == _this.storeId; });
        if (store) {
            var initiateOrder = {
                storeISOCodeThree: store[0].aliasName,
                storeID: store[0].id,
                isWWRTLItemFound: true,
                revisionNumber: '',
                validationModels: null,
                isSuccess: true
            };
            this._anonymousRetailOrderService.regenerateOrders(initiateOrder).subscribe(function (response) {
                if (response && response.isSuccess) {
                    var message = _this._translatePipe.get('retail-orders.Regenerated Orders Successfully');
                    _this._commonService.createNotification("", message.value, NotificationType.SUCCESS);
                }
                else {
                    var message = _this._translatePipe.get('retail-orders.Error occured while regenerating the orders').value;
                    _this._commonService.createNotification("", message, NotificationType.ERROR);
                }
            }, function () {
                var message = _this._translatePipe.get('customer-service.Something went wrong, Please try again after sometime').value;
                _this._commonService.createNotification("", message, NotificationType.ERROR);
            });
        }
    };
    AnonymousRetailOrderComponent.prototype.getRetailLogs = function (retailsRecords) {
        var _this = this;
        if (retailsRecords && retailsRecords.id) {
            this.overlay = true;
            this._anonymousRetailOrderService.getLogDetails(retailsRecords.id).subscribe(function (res) {
                var logResponse = __assign({}, res);
                var status = _this.populateStatuses(retailsRecords.retailBonusStatus, logResponse);
                _this.retailInfoObj = __assign({}, retailsRecords, { month: _this.monthAndYear.find(function (month) { return month.value == +retailsRecords.salesMonth; }).monthName, logStatus: status });
                _this.viewStatusPopup.open();
                _this.overlay = false;
            }, function (err) {
                _this.overlay = false;
                var message = _this._translatePipe.get('customer-service.Something went wrong, Please try again after sometime').value;
                _this._commonService.createNotification("", message, NotificationType.ERROR);
            }, function () {
                _this.overlay = false;
            });
        }
    };
    AnonymousRetailOrderComponent.prototype.initialLogStatus = function () {
        return [
            {
                logStatusID: RetailBonusStatus.PENDING,
                logMessage: this._translatePipe.get('retail-orders.' + AnonymousRetailSalesConstants.Month_End_process_is_In_Progress).value,
                logIconClass: AnonymousRetailSalesConstants.Check_icon_progress_class,
                logMsgStatus: AnonymousRetailSalesConstants.Progress,
                logStatus: AnonymousRetailSalesConstants.Completed,
                active: AnonymousRetailSalesConstants.active_Spinner_orange
            },
            {
                logStatusID: RetailBonusStatus.ORDERTOTAL_CALCULATION_INPROGRESS,
                logMessage: this._translatePipe.get('retail-orders.' + AnonymousRetailSalesConstants.Order_Total_and_CC_Calculation_is_In_Progress).value,
                logIconClass: AnonymousRetailSalesConstants.Pending_icon_class,
                logMsgStatus: AnonymousRetailSalesConstants.Progress,
                logStatus: AnonymousRetailSalesConstants.Pending,
                active: ''
            },
            {
                logStatusID: RetailBonusStatus.PRODUCT_FILE_UPLOAD_INPROGRESS,
                logMessage: this._translatePipe.get('retail-orders.' + AnonymousRetailSalesConstants.WWRTL_Product_File_Upload_In_Progress).value,
                logIconClass: AnonymousRetailSalesConstants.Pending_icon_class,
                logMsgStatus: AnonymousRetailSalesConstants.Progress,
                logStatus: AnonymousRetailSalesConstants.Pending,
                active: ''
            },
            {
                logStatusID: RetailBonusStatus.ORDER_GENERATION_INPROGRESS,
                logMessage: this._translatePipe.get('retail-orders.' + AnonymousRetailSalesConstants.Product_revision_set_with_WWRTL_Item_uploaded_to_Titan).value,
                logIconClass: AnonymousRetailSalesConstants.Pending_icon_class,
                logMsgStatus: AnonymousRetailSalesConstants.Revision,
                logStatus: AnonymousRetailSalesConstants.Pending,
                active: ""
            },
            {
                logStatusID: RetailBonusStatus.ORDER_GENERATION_INPROGRESS,
                logMessage: this._translatePipe.get('retail-orders.' + AnonymousRetailSalesConstants.Order_Creation_in_Progress).value,
                logIconClass: AnonymousRetailSalesConstants.Pending_icon_class,
                logMsgStatus: AnonymousRetailSalesConstants.Progress,
                logStatus: AnonymousRetailSalesConstants.Pending,
                active: ''
            },
            {
                logStatusID: RetailBonusStatus.PENDING,
                logMessage: this._translatePipe.get('retail-orders.' + AnonymousRetailSalesConstants.Month_End_process_is_Completed).value,
                logIconClass: AnonymousRetailSalesConstants.Pending_icon_class,
                logMsgStatus: AnonymousRetailSalesConstants.Completed,
                logStatus: AnonymousRetailSalesConstants.Pending,
                active: ''
            }
        ];
    };
    AnonymousRetailOrderComponent.prototype.populateStatuses = function (recordsStatus, logResponse) {
        var logStatuses = this.initialLogStatus().slice();
        recordsStatus = +recordsStatus;
        switch (recordsStatus) {
            case RetailBonusStatus.PENDING:
                logStatuses = this.initialLogStatus().slice();
                if (logResponse && logResponse.displayOrderCCCalculationFailLog) {
                    logStatuses = this.orderCalculationFailedLogs().slice();
                }
                break;
            case RetailBonusStatus.QUALIFIED_SUBSCRIBER_NOT_AVAILABLE:
                logStatuses = this.qualifiedSubscribersLogs().slice();
                break;
            case RetailBonusStatus.SUBSCRIBER_NOT_AVAILABLE:
                logStatuses = this.subscribersLogs().slice();
                break;
            case RetailBonusStatus.ORDERTOTAL_CALCULATION_INPROGRESS:
                logStatuses = this.orderCalculationProgressLogs().slice();
                break;
            case RetailBonusStatus.ORDERTOTAL_CALCULATION_SUCCESS:
                logStatuses = this.orderCalculationSuccessLogs().slice();
                if (logResponse && logResponse.displayReviseFailureLog) {
                    logStatuses = this.reviseFailedLog().slice();
                }
                break;
            case RetailBonusStatus.REVISE_INPROGRESS:
                logStatuses = this.reviseProgressLog().slice();
                break;
            case RetailBonusStatus.PRODUCT_FILE_UPLOAD_INPROGRESS:
                logStatuses = this.fileuploadProgress().slice();
                break;
            case RetailBonusStatus.PRODUCT_FILE_UPLOAD_SUCCESS:
                logStatuses = this.fileuploadSuccess().slice();
                break;
            case RetailBonusStatus.PRODUCT_FILE_UPLOAD_FAILED:
                logStatuses = this.fileuploadFailed().slice();
                break;
            case RetailBonusStatus.ORDER_GENERATION_INPROGRESS:
                if (logResponse && logResponse.displayWWRTLItemFoundLog) {
                    logStatuses = this.orderGenerationInProgress().slice();
                }
                else {
                    logStatuses = this.fileuploadSuccess().slice();
                }
                break;
            case RetailBonusStatus.ORDER_GENERATION_SUCCESS:
                if (logResponse && logResponse.displayWWRTLItemFoundLog) {
                    logStatuses = this.orderGenerationSuccess().slice();
                }
                else {
                    logStatuses = this.fileuploadSuccess().slice();
                }
                break;
            case RetailBonusStatus.ORDER_GENERATION_FAILED:
                logStatuses = this.orderGenerationFailed().slice();
                break;
            default:
                logStatuses = this.initialLogStatus().slice();
                break;
        }
        return logStatuses.slice();
    };
    AnonymousRetailOrderComponent.prototype.qualifiedSubscribersLogs = function () {
        return [
            {
                logStatusID: RetailBonusStatus.PENDING,
                logMessage: this._translatePipe.get('retail-orders.' + AnonymousRetailSalesConstants.Month_End_process_is_In_Progress).value,
                logIconClass: AnonymousRetailSalesConstants.Check_icon_progress_class,
                logMsgStatus: AnonymousRetailSalesConstants.Progress,
                logStatus: AnonymousRetailSalesConstants.Completed,
                active: ''
            },
            {
                logStatusID: RetailBonusStatus.QUALIFIED_SUBSCRIBER_NOT_AVAILABLE,
                logMessage: this._translatePipe.get('retail-orders.' + AnonymousRetailSalesConstants.Qualified_subscribers_are_not_available_in_this_store).value,
                logIconClass: AnonymousRetailSalesConstants.Error_icon_class,
                logMsgStatus: AnonymousRetailSalesConstants.Not_Available,
                logStatus: AnonymousRetailSalesConstants.FAILED,
                active: AnonymousRetailSalesConstants.active_Spinner_Red
            }
        ];
    };
    AnonymousRetailOrderComponent.prototype.subscribersLogs = function () {
        return [
            {
                logStatusID: RetailBonusStatus.PENDING,
                logMessage: this._translatePipe.get('retail-orders.' + AnonymousRetailSalesConstants.Month_End_process_is_In_Progress).value,
                logIconClass: AnonymousRetailSalesConstants.Check_icon_progress_class,
                logMsgStatus: AnonymousRetailSalesConstants.Progress,
                logStatus: AnonymousRetailSalesConstants.Completed,
                active: ''
            },
            {
                logStatusID: RetailBonusStatus.SUBSCRIBER_NOT_AVAILABLE,
                logMessage: this._translatePipe.get('retail-orders.' + AnonymousRetailSalesConstants.Subscribers_are_not_available_in_this_store).value,
                logIconClass: AnonymousRetailSalesConstants.Error_icon_class,
                logMsgStatus: AnonymousRetailSalesConstants.Not_Available,
                logStatus: AnonymousRetailSalesConstants.FAILED,
                active: AnonymousRetailSalesConstants.active_Spinner_Red
            }
        ];
    };
    AnonymousRetailOrderComponent.prototype.orderCalculationProgressLogs = function () {
        var initialLogs = this.initialLogStatus().slice();
        var MonthEndProcess = initialLogs.find(function (x) { return (x.logStatusID == RetailBonusStatus.PENDING && x.logMsgStatus == AnonymousRetailSalesConstants.Progress); });
        MonthEndProcess.active = '';
        var getOrderCCProgress = initialLogs.find(function (x) { return (x.logStatusID == RetailBonusStatus.ORDERTOTAL_CALCULATION_INPROGRESS && x.logMsgStatus == AnonymousRetailSalesConstants.Progress); });
        getOrderCCProgress.logIconClass = AnonymousRetailSalesConstants.Check_icon_progress_class;
        getOrderCCProgress.logStatus = AnonymousRetailSalesConstants.Completed;
        getOrderCCProgress.active = AnonymousRetailSalesConstants.active_Spinner_orange;
        return initialLogs.slice();
    };
    AnonymousRetailOrderComponent.prototype.orderCalculationSuccessLogs = function () {
        var orderCalculationProgressLogs = this.orderCalculationProgressLogs().slice();
        var orderCalculationInProgressIndex = orderCalculationProgressLogs.findIndex(function (x) { return x.logStatusID == RetailBonusStatus.ORDERTOTAL_CALCULATION_INPROGRESS && x.logMsgStatus == AnonymousRetailSalesConstants.Progress; });
        var getOrderCCCompletedLog = this.populateLogMsgDetail(RetailBonusStatus.ORDERTOTAL_CALCULATION_SUCCESS, AnonymousRetailSalesConstants.Order_Total_and_CC_Calculation_is_Completed, AnonymousRetailSalesConstants.Check_icon_class, AnonymousRetailSalesConstants.Completed, AnonymousRetailSalesConstants.Completed, AnonymousRetailSalesConstants.active_Spinner_Green);
        orderCalculationProgressLogs.splice(orderCalculationInProgressIndex, 1, getOrderCCCompletedLog);
        return orderCalculationProgressLogs.slice();
    };
    AnonymousRetailOrderComponent.prototype.orderCalculationFailedLogs = function () {
        var initialLogs = this.initialLogStatus().slice();
        var MonthEndProcess = initialLogs.find(function (x) { return (x.logStatusID == RetailBonusStatus.PENDING && x.logMsgStatus == AnonymousRetailSalesConstants.Progress); });
        MonthEndProcess.active = '';
        var getIndexOfMonthEndProcess = initialLogs.findIndex(function (x) { return (x.logStatusID == RetailBonusStatus.PENDING && x.logMsgStatus == AnonymousRetailSalesConstants.Progress); });
        var iterateOrderCCFailedLog = this.populateLogMsgDetail(RetailBonusStatus.ORDERTOTAL_CALCULATION_INPROGRESS, AnonymousRetailSalesConstants.Order_Total_and_CC_Calculation_is_Failed, AnonymousRetailSalesConstants.Error_icon_class, AnonymousRetailSalesConstants.FAILED, AnonymousRetailSalesConstants.FAILED, AnonymousRetailSalesConstants.active_Spinner_Red);
        initialLogs.splice(getIndexOfMonthEndProcess + 1, 1, iterateOrderCCFailedLog);
        return initialLogs.slice();
    };
    AnonymousRetailOrderComponent.prototype.reviseProgressLog = function () {
        var reviseLogs = this.orderCalculationSuccessLogs().slice();
        var orderCalculationSuccess = reviseLogs.find(function (x) { return (x.logStatusID == RetailBonusStatus.ORDERTOTAL_CALCULATION_SUCCESS && x.logMsgStatus == AnonymousRetailSalesConstants.Completed); });
        orderCalculationSuccess.active = '';
        var getIndexOfOrderCCSuccess = reviseLogs.findIndex(function (x) { return (x.logStatusID == RetailBonusStatus.ORDERTOTAL_CALCULATION_SUCCESS && x.logMsgStatus == AnonymousRetailSalesConstants.Completed); });
        var iterateReviseProgressLog = this.populateLogMsgDetail(RetailBonusStatus.REVISE_INPROGRESS, AnonymousRetailSalesConstants.Revise_Action_is_In_Progress, AnonymousRetailSalesConstants.Check_icon_progress_class, AnonymousRetailSalesConstants.Progress, AnonymousRetailSalesConstants.Completed, AnonymousRetailSalesConstants.active_Spinner_orange);
        reviseLogs.splice(getIndexOfOrderCCSuccess + 1, 0, iterateReviseProgressLog);
        return reviseLogs.slice();
    };
    AnonymousRetailOrderComponent.prototype.reviseFailedLog = function () {
        var reviseLogs = this.orderCalculationSuccessLogs().slice();
        var orderCalculationSuccess = reviseLogs.find(function (x) { return (x.logStatusID == RetailBonusStatus.ORDERTOTAL_CALCULATION_SUCCESS && x.logMsgStatus == AnonymousRetailSalesConstants.Completed); });
        orderCalculationSuccess.active = '';
        var getIndexOfOrderCCSuccess = reviseLogs.findIndex(function (x) { return (x.logStatusID == RetailBonusStatus.ORDERTOTAL_CALCULATION_SUCCESS && x.logMsgStatus == AnonymousRetailSalesConstants.Completed); });
        var iterateReviseProgressLog = this.populateLogMsgDetail(RetailBonusStatus.REVISE_INPROGRESS, AnonymousRetailSalesConstants.Revise_Action_is_Failed, AnonymousRetailSalesConstants.Error_icon_class, AnonymousRetailSalesConstants.FAILED, AnonymousRetailSalesConstants.FAILED, AnonymousRetailSalesConstants.active_Spinner_Red);
        reviseLogs.splice(getIndexOfOrderCCSuccess + 1, 0, iterateReviseProgressLog);
        return reviseLogs.slice();
    };
    AnonymousRetailOrderComponent.prototype.fileuploadProgress = function () {
        var fileUploadProgressLogs = this.orderCalculationSuccessLogs().slice();
        var orderCalculationSuccess = fileUploadProgressLogs.find(function (x) { return (x.logStatusID == RetailBonusStatus.ORDERTOTAL_CALCULATION_SUCCESS && x.logMsgStatus == AnonymousRetailSalesConstants.Completed); });
        orderCalculationSuccess.active = '';
        var fileUploadProgress = fileUploadProgressLogs.find(function (x) { return (x.logStatusID == RetailBonusStatus.PRODUCT_FILE_UPLOAD_INPROGRESS && x.logMsgStatus == AnonymousRetailSalesConstants.Progress); });
        fileUploadProgress.logStatus = AnonymousRetailSalesConstants.Completed;
        fileUploadProgress.active = AnonymousRetailSalesConstants.active_Spinner_orange;
        fileUploadProgress.logIconClass = AnonymousRetailSalesConstants.Check_icon_progress_class;
        return fileUploadProgressLogs.slice();
    };
    AnonymousRetailOrderComponent.prototype.fileuploadSuccess = function () {
        var fileUploadSuccessLogs = this.fileuploadProgress().slice();
        var fileUploadProgressIndex = fileUploadSuccessLogs.findIndex(function (x) { return (x.logStatusID == RetailBonusStatus.PRODUCT_FILE_UPLOAD_INPROGRESS && x.logMsgStatus == AnonymousRetailSalesConstants.Progress); });
        var iteratefileUploadSuccessLog = this.populateLogMsgDetail(RetailBonusStatus.PRODUCT_FILE_UPLOAD_SUCCESS, AnonymousRetailSalesConstants.WWRTL_Product_File_Upload_Completed, AnonymousRetailSalesConstants.Check_icon_class, AnonymousRetailSalesConstants.Completed, AnonymousRetailSalesConstants.Completed, AnonymousRetailSalesConstants.active_Spinner_Green);
        fileUploadSuccessLogs.splice(fileUploadProgressIndex, 1, iteratefileUploadSuccessLog);
        return fileUploadSuccessLogs.slice();
    };
    AnonymousRetailOrderComponent.prototype.fileuploadFailed = function () {
        var fileUploadFailedLogs = this.orderCalculationSuccessLogs().slice();
        var orderCalculationSuccess = fileUploadFailedLogs.find(function (x) { return (x.logStatusID == RetailBonusStatus.ORDERTOTAL_CALCULATION_SUCCESS && x.logMsgStatus == AnonymousRetailSalesConstants.Completed); });
        orderCalculationSuccess.active = '';
        var fileUploadProgress = fileUploadFailedLogs.find(function (x) { return (x.logStatusID == RetailBonusStatus.PRODUCT_FILE_UPLOAD_INPROGRESS && x.logMsgStatus == AnonymousRetailSalesConstants.Progress); });
        fileUploadProgress.logStatus = AnonymousRetailSalesConstants.FAILED;
        fileUploadProgress.active = AnonymousRetailSalesConstants.active_Spinner_Red;
        fileUploadProgress.logIconClass = AnonymousRetailSalesConstants.Error_icon_class;
        fileUploadProgress.logMessage = this._translatePipe.get('retail-orders.' + AnonymousRetailSalesConstants.WWRTL_Product_File_Upload_Failed).value;
        fileUploadProgress.logMsgStatus = AnonymousRetailSalesConstants.FAILED;
        return fileUploadFailedLogs.slice();
    };
    AnonymousRetailOrderComponent.prototype.orderGenerationInProgress = function () {
        var orderGenerationInProgressLogs = this.fileuploadSuccess().slice();
        var fileUploadInProgress = orderGenerationInProgressLogs.find(function (x) { return x.logStatusID == RetailBonusStatus.PRODUCT_FILE_UPLOAD_SUCCESS && x.logMsgStatus == AnonymousRetailSalesConstants.Completed; });
        fileUploadInProgress.active = '';
        var revisionSet = orderGenerationInProgressLogs.find(function (x) { return x.logStatusID == RetailBonusStatus.ORDER_GENERATION_INPROGRESS && x.logMsgStatus == AnonymousRetailSalesConstants.Revision; });
        revisionSet.active = '';
        revisionSet.logStatus = AnonymousRetailSalesConstants.Completed;
        revisionSet.logIconClass = AnonymousRetailSalesConstants.Check_icon_class;
        var orderGenerationInProgress = orderGenerationInProgressLogs.find(function (x) { return x.logStatusID == RetailBonusStatus.ORDER_GENERATION_INPROGRESS && x.logMsgStatus == AnonymousRetailSalesConstants.Progress; });
        orderGenerationInProgress.logStatus = AnonymousRetailSalesConstants.Completed;
        orderGenerationInProgress.active = AnonymousRetailSalesConstants.active_Spinner_orange;
        orderGenerationInProgress.logIconClass = AnonymousRetailSalesConstants.Check_icon_progress_class;
        return orderGenerationInProgressLogs.slice();
    };
    AnonymousRetailOrderComponent.prototype.orderGenerationSuccess = function () {
        var orderGenerationLogs = this.orderGenerationInProgress().slice();
        var monthEndInProgress = orderGenerationLogs.findIndex(function (x) { return (x.logStatusID == RetailBonusStatus.PENDING && x.logMsgStatus == AnonymousRetailSalesConstants.Progress); });
        orderGenerationLogs.splice(monthEndInProgress, 1);
        var orderGenerationSuccess = orderGenerationLogs.find(function (x) { return x.logStatusID == RetailBonusStatus.ORDER_GENERATION_INPROGRESS && x.logMsgStatus == AnonymousRetailSalesConstants.Progress; });
        orderGenerationSuccess.logIconClass = AnonymousRetailSalesConstants.Check_icon_class;
        orderGenerationSuccess.logStatus = AnonymousRetailSalesConstants.Completed;
        orderGenerationSuccess.logMsgStatus = AnonymousRetailSalesConstants.Completed;
        orderGenerationSuccess.logMessage = AnonymousRetailSalesConstants.Order_Creation_Completed;
        orderGenerationSuccess.active = '';
        var monthEndSuccess = orderGenerationLogs.find(function (x) { return x.logStatusID == RetailBonusStatus.PENDING && x.logMsgStatus == AnonymousRetailSalesConstants.Completed; });
        monthEndSuccess.logIconClass = AnonymousRetailSalesConstants.Check_icon_class;
        monthEndSuccess.logStatus = AnonymousRetailSalesConstants.Completed;
        monthEndSuccess.active = AnonymousRetailSalesConstants.active_Spinner_Green;
        return orderGenerationLogs.slice();
    };
    AnonymousRetailOrderComponent.prototype.orderGenerationFailed = function () {
        var orderGenerationFailed = this.fileuploadSuccess().slice();
        var orderFileUploadSuccess = orderGenerationFailed.find(function (x) { return x.logStatusID == RetailBonusStatus.PRODUCT_FILE_UPLOAD_SUCCESS && x.logMsgStatus == AnonymousRetailSalesConstants.Completed; });
        orderFileUploadSuccess.active = '';
        var orderFileUploadSuccessIndex = orderGenerationFailed.findIndex(function (x) { return x.logStatusID == RetailBonusStatus.PRODUCT_FILE_UPLOAD_SUCCESS && x.logMsgStatus == AnonymousRetailSalesConstants.Completed; });
        orderGenerationFailed.splice(orderFileUploadSuccessIndex + 1, 1);
        var orderGenerationInProgress = orderGenerationFailed.find(function (x) { return x.logStatusID == RetailBonusStatus.ORDER_GENERATION_INPROGRESS && x.logMsgStatus == AnonymousRetailSalesConstants.Progress; });
        orderGenerationInProgress.logStatus = AnonymousRetailSalesConstants.FAILED;
        orderGenerationInProgress.active = AnonymousRetailSalesConstants.active_Spinner_Red;
        orderGenerationInProgress.logIconClass = AnonymousRetailSalesConstants.Error_icon_class;
        orderGenerationInProgress.logMessage = this._translatePipe.get('retail-orders.' + AnonymousRetailSalesConstants.Order_Creation_Failed).value;
        orderGenerationInProgress.logMsgStatus = AnonymousRetailSalesConstants.FAILED;
        return orderGenerationFailed.slice();
    };
    AnonymousRetailOrderComponent.prototype.populateLogMsgDetail = function (status, msg, iconClass, msgStatus, logStatus, active) {
        return {
            logStatusID: status,
            logMessage: this._translatePipe.get('retail-orders.' + msg).value,
            logIconClass: iconClass,
            logMsgStatus: msgStatus,
            logStatus: logStatus,
            active: active
        };
    };
    AnonymousRetailOrderComponent.prototype.statusClose = function () {
        this.viewStatusPopup.close();
    };
    return AnonymousRetailOrderComponent;
}());
export { AnonymousRetailOrderComponent };



// WEBPACK FOOTER //
// ./src/app/customerservice/components/orders/anonymous-retail-order.component.ts.pre-build-optimizer.js